import InfiniteScroll from 'react-infinite-scroll-component';
import style from './search-items-list.module.scss';
import { TArticle, TComment, TUser } from '../../../models/common';
import MembersListItem from '../members-list-item/members-list-item';
import ArticleListItem from '../article-list-item/article-list-item';
import CommentListItem from '../comment-list-item/comment-list-item';
import { Divider } from '@mui/material';

interface SearchItemsListProps {
  hasMore: boolean;
  data: TUser[] | TComment[] | TArticle[];
  fetchData: () => void;
}

function SearchItemsList({ hasMore, data, fetchData }: SearchItemsListProps) {
  const getItem = (item: TUser | TComment | TArticle, key: number) => {
    if ('username' in item) {
      return <MembersListItem user={item} key={key} />;
    } else if ('content' in item) {
      return <ArticleListItem article={item} key={key} />;
    } else {
      return <CommentListItem comment={item} key={key} />;
    }
  };

  return (
    <div className={style.searchItemsList}>
      <InfiniteScroll
        className={style.items}
        dataLength={data.length}
        next={fetchData}
        hasMore={hasMore}
        loader={''}
        height={650}
      >
        {data.map((item, index) => {
          return (
            <>
              {getItem(item, index)}
              <Divider key={`divider-${index}`} />
            </>
          );
        })}

        {!hasMore ? (
          <p className={style.hasmore}>
            <b>No more data to show</b>
          </p>
        ) : (
          ''
        )}
      </InfiniteScroll>
    </div>
  );
}

export default SearchItemsList;
